import { path, httpService } from '@commons';

/////////////////////////////////////////////////////////////////////////////////
const args = { ...path, path: '/produtoAgricola' };
/////////////////////////////////////////////////////////////////////////////////

export function createProdutoAgricolaCadastro(payload) {
  return httpService.post(args, payload);
}

export function updateProdutoAgricolaCadastro(payload) {
  const { id } = payload

  return httpService.put({ ...args, args: `/${id}` }, payload);
}

export function listProdutoAgricolaCadastro(param) {
  return httpService.get({...args, args: param});
}

export function findProdutoAgricolaCadastro(id) {
  return httpService.get({ ...args, args: `/${id}` });
}

export function findAllProdutoAgricolaCadastro() {
  return httpService.get({ ...args, path: '/produtoAgricola/all' });
}

export function deleteProdutoAgricolaCadastro(id) {
  return httpService.del({ ...args, args: `/${id}` });
}

